import {Steps} from "../constants/constants";

interface Props {
    files: any
    setFiles: (files: any) => void
    step: string
    setLoading: (loading: boolean) => void
}

const FilesUpload = (props: Props) => {

    const {files, setFiles, step} = props

    if (step === Steps.CONFIRMED) {
        return null
    }

    const handleChange = (event: any) => {
        if (!event.target.files[0]) return
        Object.values(event.target.files).map((file: any) => {
            if (file.size > 10_000000) { // 10MB
                alert(`Bestandsgroote van ${file.name} is te groot, maximaal 10MB.`)
                return
            }
            setFiles(files => [...files, file])
        })
    }

    return (
        <div className="c-file-upload">

            <form>
                {(step === Steps.CONFIRM && files.length < 1) &&
                    <p className="p-repair-form__subtitle">Voeg tenminste één foto toe bij documenten om de
                        melding in te kunnen dienen</p>
                }

                <div className=".c-file-upload__uploaded-files">
                    {files.length > 0 ? files.map((file: any, index: number) =>
                        <p key={file.name + index} className=".c-file-upload__uploaded-files__file">
                            {'Bestand ' + (index + 1) + ': ' + file.name}
                        </p>
                    ) : <p className="c-file-upload__uploaded-files__file">Nog geen foto's toegevoegd</p>}
                </div>
                <div className="c-file-upload__drop-file-area">
                    <label htmlFor="file">Klik of sleep hier je bestanden heen</label>
                    <input multiple="multiple" type="file" accept="image/*,video/*" name="file" onChange={handleChange}
                    />
                </div>
            </form>
        </div>
    )

}
export default FilesUpload;